import * as _ from "lodash";
import * as React from "react";

interface ILoadingSpinnerProps{
	text?: string;
}

export class LoadingSpinner extends React.Component<ILoadingSpinnerProps, undefined>
{
	constructor(props, state){
		super(props, state);
	}

	render(){
		let text = _.isNil(this.props.text) ? "Loading" : this.props.text;
		return (
			<div className="dimmer-container">
				<div className="ui active dimmer">
					<div className="ui text loader">{text}</div>
				</div>
			</div>
		);

	}
}



// WEBPACK FOOTER //
// ./src/views/common/loading-spinner.tsx